import { render, staticRenderFns } from "./CorporateChangePasswordComponent.vue?vue&type=template&id=12102b44&"
import script from "./CorporateChangePasswordComponent.vue?vue&type=script&lang=js&"
export * from "./CorporateChangePasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports